import { Box, SimpleGrid } from '@chakra-ui/react';
import { items } from './NavItemIcons';
import { CartCount } from './CartCount';
import { NavAction } from './NavAction';

type Props = {
  onCartClick: () => void;
  onRequestClick: () => void;
  onSearchClick: () => void;
};

export const MobileBottomNav = (props: Props) => (
  <Box
    bg='white'
    pos='fixed'
    width='full'
    bottom='0'
    pb='env(safe-area-inset-bottom)'
    borderTopWidth='1px'
    borderColor='gray.200'
    boxShadow='0 -4px 12px rgba(0, 0, 0, 0.08)'
    display={{ lg: 'none' }}
    zIndex='sticky'>
    <SimpleGrid columns={4} py='1' px='2'>
      <NavAction.Mobile {...items.search} onClick={props.onSearchClick} />
      <NavAction.Mobile {...items.cart} onClick={props.onCartClick}>
        <CartCount right='-2' />
      </NavAction.Mobile>
      <NavAction.Mobile {...items.request} onClick={props.onRequestClick} />
      <NavAction.Mobile {...items.user} />
    </SimpleGrid>
  </Box>
);
